<template>
  <div class="comment-input-box">
    <el-dialog title="评论" :visible="showCommentPop" :close-on-click-modal="false" @close="onClickClose">
      <div class="">
        <div class="">
          <el-input type="textarea" :rows="5" placeholder="请输入评论" v-model="textarea" resize="none">
          </el-input>
        </div>
        <div class="input-textarea-btn">
          <el-button class="textarea-btn" @click="sendInput" :disabled="isdisabled()">发送</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addForumComment } from '@/api/forum'
import { addInformationComment } from '@/api/home'

export default {
  data() {
    return {
      textarea: '',
    }
  },
  props: {
    showCommentPop: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    isForum: {
      type: String,
      default: '0',
    }
  },
  methods: {
    addForumComment() {
      addForumComment({
        content: this.textarea,
        noteId: this.id,
      }).then(res => {
        if(res.code == "A00000") {
          this.$message.success('评论成功!');
          this.onClickClose()
        }
      })
    },
    // 新增资讯评论
    addInformationComment() {
      addInformationComment({
        content: this.textarea,
        informationId: this.id,
        userId: JSON.parse(localStorage.getItem('userInfo')).id,
      }).then(res => {
        if (res.code == "A00000") {
          this.$message.success('评论成功!');
          this.onClickClose()
        }
      })
    },
    sendInput() {
      if(this.isForum == '1') {
        this.addForumComment()
      }else {
        this.addInformationComment()
      }
    },
    isdisabled() {
      if(this.textarea == '') {
        return true
      }
      return false
    },
    onClickClose() {
      this.$emit('update:showCommentPop', false);
    }
  }
}
</script>

<style lang="less" scoped>
.comment-input-box {
  .input-textarea-btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .textarea-btn {
      background: #9C1D22;
      color: #FFFFFF;
      width: 200px;
      height: 54px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/base/commentInput.vue